module.exports = __webpack_public_path__ + "static/media/icon_mfr.png";


//////////////////
// WEBPACK FOOTER
// ./src/icon_mfr.png
// module id = 1012
// module chunks = 0